const SIGN_UP_ENDPOINT = '/api/v1/users/register';
const SIGN_IN_ENDPOINT = '/api/v1/users/login';
require('es6-promise').polyfill();
import fetch from 'isomorphic-fetch';
export default class NewUserHttpClient {

  signUp = user => {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return fetch(SIGN_UP_ENDPOINT, { body: JSON.stringify(user), headers: headers, method: 'POST'})
      .then( response => this.handleResponse(response));
  };

  signIn = data => {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return fetch(SIGN_IN_ENDPOINT, { body: JSON.stringify(data), headers: headers, method: 'POST'})
           .then( response => this.handleResponse(response));
  };

  handleResponse = response => {
    if(response.status >= 300 || response.status < 200)
      throw response;
     else
      return response.json()
  }
}



// WEBPACK FOOTER //
// ./src/services/NewUserHttpService.js